<template>
    <painel-component :itens="itensOne">

        <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 filter-position'"
                           v-if="btnFilter">
            <button class="btn-filter" @click="filterWindow">
                <i class="filter icon"></i>
            </button>
        </row-col-component>

        <form class="mb-4 mt-5">
            <transition name="fade-in-top">
                <row-component v-if="filter">
                    <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Nome:</label>
                        <input-component :type-input="'text'" v-model="formDate.name" :placeholder="'Digite o nome'"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>CNPJ:</label>
                        <input-component :type-input="'text'" v-model="formDate.cnpj"
                                         :placeholder="'00.000.000/0000-00'" v-mask="'##.###.###/####-##'"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>CPF:</label>
                        <input-component :type-input="'text'" v-model="formDate.cpf" :placeholder="'000.000.000-00'"
                                         v-mask="'###.###.###-##'"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Serviço:</label>
                        <Multiselect v-model="formDate.service" :searchable="true" :options="selectServiceClient"
                                     :noResultsText="this.$store.state.var.selectNotSearch"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Status:</label>
                        <multiselect v-model="formDate.status" :searchable="true" :options="selectInput"
                                     :noResultsText="this.$store.state.var.selectNotSearch"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Parceiro:</label>
                        <multiselect v-model="formDate.partner" :searchable="true" :options="selectAttended"
                                     :noResultsText="this.$store.state.var.selectNotSearch"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mt-0 mt-xl-4'">
                        <button-one class="mx-1" @submit="submit" :icon="'search'" :nameButton="''"/>
                        <button-float class="mx-1" v-if="buttonCheck.create" :itens="itensTwo"/>
                    </row-col-component>
                </row-component>
            </transition>
        </form>

        <loder-send-component :text-title="'Carregando'" v-if="showLoder"/>

        <div v-else>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col" style="width: 35%">Nome</th>
                    <th scope="col" style="width: 15%">CPF / CNPJ</th>
                    <th scope="col" style="width: 20%">Status</th>
                    <th scope="col" style="width: 10%" v-if="buttonCheck.show || buttonCheck.edit">Ações</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="(client, index) in clients.data" :key="index">
                    <td data-label="Nome">
                        <img v-if="client.photo" :src="client.photo" class="avatar__image_2" alt="">
                        <img v-else src="@/assets/img/avatar.png" class="avatar__image_2" alt="">
                        {{ client.surname }}
                    </td>
                    <td data-label="CPF / CNPJ">{{ client.cpf }} {{ client.cnpj }}</td>
                    <td data-label="Status">{{ statusString(client.status) }}</td>
                    <td data-label="Ações" v-if="buttonCheck.show || buttonCheck.edit">
                        <button-show-round :route="'client-show'" :id-param="client.id" v-if="buttonCheck.show"/>
                        <button-edit-round :route="'client-edit'" :id-param="client.id" v-if="buttonCheck.edit"/>
                    </td>
                </tr>
                </tbody>
            </table>

            <button-pagination :pagination="clients" :offset="3" @paginate="loadClients"/>
        </div>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import ButtonOne from "@/components/buttons/ButtonOne";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import ButtonPagination from "@/components/buttons/ButtonPagination";
import InputComponent from "@/components/form/InputComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import ButtonShowRound from "@/components/buttons/ButtonShowRound";
import ButtonEditRound from "@/components/buttons/ButtonEditRound";
import LoderSendComponent from "@/components/LoderSendComponent";
import Multiselect from "@vueform/multiselect";

import {mask} from 'vue-the-mask'
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "ClientSearch",
    components: {
        PainelComponent,
        ButtonOne,
        ButtonFloat,
        ButtonPagination,
        InputComponent,
        RowComponent,
        RowColComponent,
        ButtonShowRound,
        ButtonEditRound,
        LoderSendComponent,
        Multiselect,
    },

    directives: {
        mask
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Cliente')
        this.loadClients(1)
        this.checkACL()
        if (window.innerWidth <= 991) {
            this.filter = false
            this.btnFilter = true
        }
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "list alternate"
            },

            itensTwo: {
                route: "/client/create",
                icon: "plus",
                tooltip: '',
                name: ''
            },

            page: 1,
            pagination: [],

            formDate: {
                name: '',
                cnpj: '',
                cpf: '',
                status: 1,
                photo: '',
                service: '',
                partner: ''
            },

            filter: true,
            btnFilter: false,

            showLoder: true,
            searchSubmit: false,

            buttonCheck: {
                edit: false,
                create: false,
                show: false
            }
        }
    },

    methods: {
        submit() {
            this.loadClients(1)
            this.searchSubmit = true;
        },

        loadClients(page) {
            this.showLoder = true
            if (!this.searchSubmit) {
                this.$store.dispatch('loadClients', {...this.params, page})
                    .then((r) => {
                        this.showLoder = false
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 10000});
                            }
                        }
                    }).catch(() => {
                    this.showLoder = false
                    this.searchSubmit = false;
                });
            }
        },

        filterWindow() {
            this.filter = !this.filter
        },

        statusString(value) {
            if (parseInt(value) === 1)
                return 'Ativo'
            return 'Inativo'
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 4)
                .then((r) => {
                    if (r.data.indexOf('client-search') !== -1) {
                        this.showLoder = false

                        if (r.data.indexOf('client-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('client-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('client-create') !== -1) {
                            this.buttonCheck.create = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },
    },

    computed: {
        selectServiceClient() {
            return this.$store.state.var.selectServiceClient;
        },

        selectInput() {
            return this.$store.state.var.selectActiveInactiveSearch;
        },

        selectAttended() {
            return this.$store.state.var.selectAttended;
        },

        clients() {
            return this.$store.state.client.items
        },

        params() {
            return {
                page: this.clients.current_page,
                name: this.formDate.name,
                status: this.formDate.status,
                cpf: this.formDate.cpf,
                cnpj: this.formDate.cnpj,
                service: this.formDate.service,
                partner: this.formDate.partner,
            }
        },
    }
}
</script>
<style src="@/assets/css/table-resp.css" scoped></style>

<style scoped>
.avatar__image_2 {
    width: 30px;
    height: 30px;
    object-fit: cover;
    margin-right: 10px;
    border-radius: 50%;
    border: 1px solid #d67c1c;
}
</style>